module.exports = __webpack_public_path__ + "static/media/8.a1d05549.png";